export class SecureFileError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "SecureFileError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/** Wrong magic bytes, unknown version, malformed structure, or iteration bound violation. */
export class MalformedContainerError extends SecureFileError {
  constructor(message: string) {
    super(message);
    this.name = "MalformedContainerError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/**
 * Wrong passphrase OR tampered ciphertext. Web Crypto cannot distinguish
 * between the two — AES-GCM auth failure always throws a generic OperationError.
 * The message acknowledges the ambiguity.
 */
export class InvalidPassphraseError extends SecureFileError {
  constructor(
    message = "Passphrase didn't match. If you're sure the passphrase is correct, the file may be damaged.",
  ) {
    super(message);
    this.name = "InvalidPassphraseError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

/** Reserved for cases where corruption is positively identifiable. */
export class CorruptedFileError extends SecureFileError {
  constructor(message: string) {
    super(message);
    this.name = "CorruptedFileError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
